import type mapboxgl from 'mapbox-gl';

interface Continent {
  label: string;
  bounds: [[number, number], [number, number]]; // [[sw], [ne]]
}

const CONTINENTS: Continent[] = [
  { label: 'World',    bounds: [[-180, -60], [180, 75]] },
  { label: 'Europe',   bounds: [[-25, 35],  [45, 71]] },
  { label: 'N. America', bounds: [[-170, 15], [-50, 72]] },
  { label: 'S. America', bounds: [[-85, -56], [-30, 13]] },
  { label: 'Africa',   bounds: [[-20, -37], [55, 38]] },
  { label: 'Asia',     bounds: [[25, 0],   [145, 75]] },
  { label: 'Oceania',  bounds: [[110, -50], [180, 0]] },
];

interface MapControlsProps {
  map: mapboxgl.Map | null;
}

export function MapControls({ map }: MapControlsProps) {
  const flyTo = (continent: Continent) => {
    if (!map) return;
    map.fitBounds(continent.bounds as mapboxgl.LngLatBoundsLike, { padding: 20, duration: 1200 });
  };

  return (
    <div
      style={{
        position: 'absolute',
        bottom: 80,
        right: 10,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        zIndex: 10,
      }}
    >
      {CONTINENTS.map((c) => (
        <button
          key={c.label}
          onClick={() => flyTo(c)}
          title={`Zoom to ${c.label}`}
          style={{
            background: '#fff',
            border: '1px solid #e0e0e0',
            borderRadius: 6,
            padding: '4px 8px',
            fontSize: 11,
            cursor: 'pointer',
            boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
            whiteSpace: 'nowrap',
          }}
        >
          {c.label}
        </button>
      ))}
    </div>
  );
}
